// JIRA LPPLWEBMOB-563
export enum ComponentId {
  CORRECTNESS_AGREEMENT = "correctnessAgreement",
  AGREE_DECISION_EMAIL = "AgreeDecisionEmail",
  AGREE_RENTIN_VEHICLE_EMAIL = "AgreeRentinVehicleEmail",
  AGREE_CONTACT_EMAIL = "AgreeContactEmail",
}
